module.exports = __webpack_public_path__ + "static/img/home_banner2.662ac40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_banner2.png
// module id = aVW+
// module chunks = 1